<template>
    <div class="lang-switcher">
        <img class="lang-btn" src="@/assets/images/language.png" alt="Language" @click="open = !open" />
        <div class="lang-dropdown" v-show="open">
            <div
                class="lang-item"
                v-for="opt in options"
                :key="opt.value"
                :class="{ active: value === opt.value }"
                @click="$emit('input', opt.value); open = false"
            >{{ opt.label }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        options: Array
    },
    data() {
        return { open: false }
    },
    mounted() {
        document.addEventListener('click', this.onClickOutside)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.onClickOutside)
    },
    methods: {
        onClickOutside(e) {
            if (!this.$el.contains(e.target)) {
                this.open = false
            }
        }
    }
}
</script>

<style scoped lang="less">
.lang-switcher {
    position: fixed;
    top: 1.5rem;
    right: 1.5rem;
    z-index: 100;
    .lang-btn {
        cursor: pointer;
        height: 2.5rem;
        display: block;
    }
    .lang-dropdown {
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 0.5rem;
        background: rgba(0, 0, 0, 0.75);
        border-radius: 0.5rem;
        overflow: hidden;
        min-width: 8rem;
        box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.3);
        .lang-item {
            padding: 0.6rem 1rem;
            color: #fff;
            font-size: 1rem;
            cursor: pointer;
            white-space: nowrap;
            text-align: center;
            font-family: 'CookieRunBold';
            &:hover {
                background: rgba(255, 255, 255, 0.15);
            }
            &.active {
                color: #227bfe;
            }
        }
    }
}
</style>
